<template>
  <v-card class="roteirizacao-form-card">
    <v-card-title>{{ $t('routePlanning.modules.alocation') }}</v-card-title>
    <v-card-text>
      <v-form ref="formAlocation" v-model="formValidLocal">
        <v-row class="mt-4 mb-2">
          <v-col
            v-for="card in allocationPassengerKpiCards"
            :key="card.key"
            cols="12"
            sm="6"
            md="3"
            class="d-flex"
          >
            <v-card class="pa-3 flex-grow-1" outlined style="border-radius: 10px;">
              <div class="text-caption grey--text text--darken-1">{{ card.label }}</div>
              <div class="text-h5 font-weight-bold" :style="{ color: card.color }">
                {{ card.value }}
              </div>
            </v-card>
          </v-col>
        </v-row>
        <div class="allocation-filters-panel">
          <div class="allocation-filters-grid">
            <div class="allocation-filter-field">
              <v-select
                :value="groupFilter"
                :items="groupFilterItems"
                :label="$t('routePlanning.fields.selectGroup')"
                item-text="text"
                item-value="value"
                clearable
                @input="$emit('update:groupFilter', $event)"
              />
            </div>
            <div class="allocation-filter-field">
              <v-select
                :value="lineFilter"
                :items="lineFilterItems"
                :label="$t('routePlanning.fields.selectLine')"
                item-text="text"
                item-value="value"
                clearable
                @input="$emit('update:lineFilter', $event)"
              />
            </div>
            <div class="allocation-filter-field">
              <LazySelect
                ref="unitSelect"
                get-url="getUnidadeslazy"
                text="descricao_unidade"
                value="id_unidade"
                :label="$t('routePlanning.fields.unit')"
                :extra-items="semUnidadeExtraItems"
                @input="onUnitInput"
              />
            </div>
            <div v-if="isAllocationNoUnitFilter" class="allocation-filter-field">
              <v-select
                :value="allocationValidationUnitId"
                :items="allocationValidationUnitItems"
                :label="$t('routePlanning.fields.validationUnit')"
                item-text="text"
                item-value="value"
                :hint="$t('routePlanning.fields.validationUnitHint')"
                persistent-hint
                clearable
                @input="$emit('update:allocationValidationUnitId', $event)"
              />
            </div>
            <div class="allocation-filter-field">
              <LazySelect
                ref="agencySelect"
                get-url="getAgenciasempregolazy"
                :text="agencyItemText"
                value="id_agencia_emprego"
                :label="$t('routePlanning.fields.selectAgency')"
                :extra-items="semAgenciaExtraItems"
                @input="onAgencyInput"
              />
            </div>
            <div class="allocation-filter-field">
              <v-select
                :value="companyFilter"
                :items="companyPickItems"
                :label="$t('routePlanning.fields.selectCompany')"
                item-text="text"
                item-value="value"
                clearable
                @input="$emit('update:companyFilter', $event)"
              />
            </div>
            <div class="allocation-filter-field">
              <v-select
                :value="clientFilter"
                :items="clientPickItems"
                :label="$t('routePlanning.fields.selectClient')"
                item-text="text"
                item-value="value"
                clearable
                @input="$emit('update:clientFilter', $event)"
              />
            </div>
            <div class="allocation-filter-field">
              <MultiplaEscolha
                ref="allocationTurnosRef"
                text="descricao_turno"
                value="id_turno"
                :items="turnosParaFiltroAlocacao"
                can-toggle-all
                :label="$t('candidate.jobOffer.shift')"
                :max-items="3"
                @update:selectedItems="$emit('update:filtroTurnosSelected', $event)"
              />
            </div>
            <div class="allocation-filter-field">
              <v-menu
                v-model="insertionStartMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="allocationInsertionStartFormatted"
                    :label="$t('routePlanning.fields.insertionDateStart')"
                    prepend-icon="mdi-calendar"
                    readonly
                    clearable
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="$emit('update:allocationInsertionStart', null)"
                  />
                </template>
                <v-date-picker
                  :value="allocationInsertionStart"
                  no-title
                  scrollable
                  :locale="$i18n.locale"
                  @input="onInsertionStart($event)"
                />
              </v-menu>
            </div>
            <div class="allocation-filter-field">
              <v-menu
                v-model="insertionEndMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="allocationInsertionEndFormatted"
                    :label="$t('routePlanning.fields.insertionDateEnd')"
                    :error-messages="allocationDateRangeError"
                    prepend-icon="mdi-calendar"
                    readonly
                    clearable
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="$emit('update:allocationInsertionEnd', null)"
                  />
                </template>
                <v-date-picker
                  :value="allocationInsertionEnd"
                  no-title
                  scrollable
                  :locale="$i18n.locale"
                  @input="onInsertionEnd($event)"
                />
              </v-menu>
            </div>
          </div>
          <div class="allocation-passenger-actions">
            <div class="allocation-passenger-selector">
              <MultiplaEscolha
                ref="allocationPassengersRef"
                lazy
                get-url="getPessoasroteirizacaolazy"
                :request-data="passengersLazyRequestData"
                :items="selectedPassengersForAllocation"
                text="nome_completo"
                value="id_pessoa"
                can-toggle-all
                :label="$t('routePlanning.dialogs.addStop.selectPassengers')"
                :disabled="passengersLoading"
                @update:selectedItems="$emit('update:allocationSelectedPassengerIds', $event)"
                @update:allMatchingSelected="onPassengersAllMatching"
              />
            </div>
            <div class="allocation-validate-button-wrap">
              <v-menu offset-y :close-on-content-click="false" min-width="300">
                <template v-slot:activator="{ on, attrs }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on: onTooltip }">
                      <v-btn
                        color="#4a4a4a"
                        dark
                        small
                        class="mr-2"
                        fab
                        v-bind="attrs"
                        v-on="{ ...onTooltip, ...on }"
                      >
                        <v-icon>mdi-tune-variant</v-icon>
                      </v-btn>
                    </template>
                    <div>{{ $t('candidate.validationOptions.title') }}</div>
                  </v-tooltip>
                </template>
                <v-card>
                  <v-card-title class="text-subtitle-2 py-2">
                    {{ $t('candidate.validationOptions.title') }}
                  </v-card-title>
                  <v-divider />
                  <v-card-text class="py-2">
                    <v-switch
                      :input-value="validacaoConsiderarTempoPermanencia"
                      dense
                      hide-details
                      class="mt-0"
                      :label="$t('candidate.validationOptions.considerRideTime')"
                      @change="$emit('update:validacaoConsiderarTempoPermanencia', $event === true)"
                    />
                    <v-text-field
                      :value="validacaoTempoMaximoPermanencia"
                      :disabled="!validacaoConsiderarTempoPermanencia"
                      type="number"
                      min="1"
                      suffix="min"
                      dense
                      clearable
                      class="mt-3"
                      :label="$t('candidate.validationOptions.maxRideTime')"
                      :hint="$t('candidate.validationOptions.maxRideTimeHint')"
                      persistent-hint
                      @input="$emit('update:validacaoTempoMaximoPermanencia', $event)"
                    />
                  </v-card-text>
                </v-card>
              </v-menu>
              <v-btn
                color="primary"
                class="allocation-validate-button"
                dark
                :disabled="!canClickValidate"
                @click="onValidateClick"
              >
                <v-icon left>mdi-magnify</v-icon>
                {{ $t('routePlanning.actions.validate') }}
              </v-btn>
            </div>
          </div>
        </div>
        <v-row>
          <v-col cols="12" md="12">
            <merus-data-table
              :headers="allocationTableHeaders"
              :items="validatedAddresses"
              item-key="id_pessoa"
              :default-multi-sort="allocationSortDefaults"
              :loading="addressesLoading"
              :show-select="true"
              :server-items-length="validatedTotal"
              :items-per-page="validatedNumberOfRows"
              :items-per-page-last-option="validatedItemsPerPageLastOption"
              :server-sort-by="validatedServerSortBy"
              :server-sort-desc="validatedServerSortDesc"
              :key="`alloc-validation-${(filtroTurnosSelected || []).join('-')}`"
              ref="allocationTable"
              @input="$emit('table-selection', $event)"
              @toggle-select-all="$emit('toggle-select-all', $event)"
              @update:options="$emit('validated-options', $event)"
              @update:filters="$emit('validated-filters', $event)"
              @click:row="$emit('click:validation-row', $event)"
            >
              <template v-slot:toolbar>
                <cadastro-toolbar
                  :title="$t('routePlanning.addressValidation')"
                  :token="token"
                  :items="validatedAddresses"
                  :load-items-for-export="loadValidatedItemsForExport"
                  :csv-title="$t('routePlanning.addressValidation')"
                  :csv-headers="allocationTableHeadersForExport"
                  :pdf-title="$t('routePlanning.addressValidation')"
                  :pdf-headers="allocationTableHeadersForExport"
                  hide-search
                >
                  <template v-slot:extension>
                    <v-tooltip top>
                      <span>{{ $t('routePlanning.actions.allocateSelected') }}</span>
                    </v-tooltip>
                  </template>
                </cadastro-toolbar>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-icon
                  v-if="!isRejectedAllocationRow(item)"
                  small
                  class="mr-2"
                  :color="allocationCanAllocate ? 'green' : 'grey'"
                  :style="allocationCanAllocate ? '' : 'pointer-events: none; opacity: 0.5;'"
                  @click="allocationCanAllocate && $emit('allocate-one', item)"
                >mdi-map-marker-account</v-icon>
              </template>
            </merus-data-table>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on" class="d-inline-block mr-2">
            <!-- Botao unico de rejeitados, sempre habilitado. Sem selecao na
                 tabela ele aloca TODOS os rejeitados do filtro atual; havendo
                 selecao, passa a valer so o que esta marcado -- rotulo, contador
                 e tooltip vem prontos do pai, que decide o modo. As validacoes
                 (periodo, existencia de rejeitados) acontecem no handler, que
                 avisa o usuario em vez de falhar em silencio. -->
            <v-btn
              color="error"
              outlined
              :loading="allRejectedAllocationLoading"
              @click="$emit('open-rejected')"
            >
              <v-icon left>mdi-account-cancel</v-icon>
              {{ rejectedAllocationButtonLabel }}
              <v-chip
                v-if="rejectedAllocationButtonCount"
                x-small
                color="error"
                text-color="white"
                class="ml-2"
              >
                {{ rejectedAllocationButtonCount }}
              </v-chip>
            </v-btn>
          </span>
        </template>
        <span>{{ rejectedAllocationButtonTooltip }}</span>
      </v-tooltip>
      <v-btn
        color="primary"
        :disabled="!allocationCanAllocate || !allocationSelection.length"
        dark
        @click="$emit('allocate-selection')"
      >{{ $t('routePlanning.actions.allocate') }}</v-btn>
    </v-card-actions>
    <v-card-text class="pt-0">
      <merus-data-table
        cod-tabela="DIAGINCONSISTENCIADADOS__PASSAGEIROS"
        :headers="incompletePassengersTableHeaders"
        :items="incompletePassengers"
        :loading="incompletePassengersLoading"
        :server-items-length="incompleteTotal"
        :items-per-page="incompleteNumberOfRows"
        :items-per-page-last-option="incompleteItemsPerPageLastOption"
        :server-sort-by="incompleteServerSortBy"
        :server-sort-desc="incompleteServerSortDesc"
        item-key="id_pessoa"
        :item-class="incompletePassengersRowClass"
        @update:headers="$emit('update:incompletePassengersTableHeaders', $event)"
        @update:options="$emit('incomplete-options', $event)"
        @update:filters="$emit('incomplete-filters', $event)"
        @click:row="$emit('click:incomplete-row', $event)"
      >
        <template v-slot:toolbar>
          <cadastro-toolbar
            :title="$t('diagDataInconsistencies.tabs.passengers')"
            :token="token"
            :items="incompletePassengers"
            :load-items-for-export="loadIncompleteItemsForExport"
            csv-title="diaginconsistenciapassageiros"
            :csv-headers="incompletePassengersTableHeaders"
            :pdf-title="$t('diagDataInconsistencies.tabs.passengers')"
            :pdf-headers="incompletePassengersTableHeaders"
            pdf-filename="diaginconsistenciapassageiros"
            hide-search
          />
        </template>
      </merus-data-table>
    </v-card-text>
    <v-card-text class="pt-0">
      <merus-data-table
        cod-tabela="ROTEIRIZACAO__AGLOMERADOS_REJEITADOS"
        :headers="rejectedAgglomerationTableHeaders"
        :items="rejectedAgglomerationClusters"
        :loading="passengersLoading"
        :mostrar-inativos="true"
        item-key="key"
        item-class="cursor-pointer"
        @update:headers="$emit('update:rejectedAgglomerationTableHeaders', $event)"
        @click:row="$emit('click:rejected-row', $event)"
      >
        <template v-slot:toolbar>
          <cadastro-toolbar
            :title="$t('routePlanning.rejectedAgglomeration.title')"
            :token="token"
            :items="rejectedAgglomerationClusters"
            csv-title="aglomeradosrejeitados"
            :csv-headers="rejectedAgglomerationTableHeaders"
            :pdf-title="$t('routePlanning.rejectedAgglomeration.title')"
            :pdf-headers="rejectedAgglomerationTableHeaders"
            pdf-filename="aglomeradosrejeitados"
            hide-search
          />
        </template>
      </merus-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import MultiplaEscolha from '@/components/Selects/MultiplaEscolha.vue';
import LazySelect from '@/components/Selects/LazySelect.vue';
import MerusDataTable from '@/components/Tables/MerusDataTable.vue';
import CadastroToolbar from '@/components/Toolbars/CadastroToolbar.vue';

const UNIT_FILTER_NONE = -1;
const AGENCY_FILTER_NONE = -1;

export default {
  name: 'RoteirizacaoAlocacaoPanel',
  components: { MultiplaEscolha, LazySelect, MerusDataTable, CadastroToolbar },
  props: {
    token: { type: String, default: '' },
    allocationFormValid: { type: Boolean, default: false },
    groupFilter: { default: null },
    lineFilter: { default: null },
    unitFilter: { default: null },
    agencyFilter: { default: null },
    companyFilter: { default: null },
    clientFilter: { default: null },
    filtroTurnosSelected: { type: Array, default: () => [] },
    allocationValidationUnitId: { default: null },
    /** Desligado, o tempo a bordo só é exibido: nenhuma linha é reprovada por ele. */
    validacaoConsiderarTempoPermanencia: { type: Boolean, default: true },
    /** Override manual do limite de permanência na linha; vazio herda linha/unidade/config. */
    validacaoTempoMaximoPermanencia: { default: null },
    allocationInsertionStart: { default: null },
    allocationInsertionEnd: { default: null },
    allocationSelectedPassengerIds: { type: Array, default: () => [] },
    groupFilterItems: { type: Array, default: () => [] },
    lineFilterItems: { type: Array, default: () => [] },
    unitPickItems: { type: Array, default: () => [] },
    agencyPickItems: { type: Array, default: () => [] },
    companyPickItems: { type: Array, default: () => [] },
    clientPickItems: { type: Array, default: () => [] },
    turnosParaFiltroAlocacao: { type: Array, default: () => [] },
    selectedTurnosForAllocationFilter: { type: Array, default: () => [] },
    allocationValidationUnitItems: { type: Array, default: () => [] },
    isAllocationNoUnitFilter: { type: Boolean, default: false },
    allocationInsertionStartFormatted: { type: String, default: '' },
    allocationInsertionEndFormatted: { type: String, default: '' },
    allocationDateRangeError: { type: [String, Array], default: '' },
    passengersLazyRequestData: { type: Object, default: () => ({}) },
    selectedPassengersForAllocation: { type: Array, default: () => [] },
    passengersLoading: { type: Boolean, default: false },
    allocationCanValidate: { type: Boolean, default: false },
    allocationCanAllocate: { type: Boolean, default: false },
    allocationTableHeaders: { type: Array, default: () => [] },
    allocationTableHeadersForExport: { type: Array, default: () => [] },
    validatedAddresses: { type: Array, default: () => [] },
    validatedTotal: { type: Number, default: 0 },
    validatedNumberOfRows: { type: Number, default: 10 },
    validatedItemsPerPageLastOption: { type: Number, default: 1000 },
    validatedServerSortBy: { type: Array, default: () => [] },
    validatedServerSortDesc: { type: Array, default: () => [] },
    loadValidatedItemsForExport: { type: Function, default: null },
    bulkAddresses: { type: Array, default: () => [] },
    allocationSortDefaults: { type: Array, default: () => [] },
    addressesLoading: { type: Boolean, default: false },
    turnoColumnHeadersAlocacao: { type: Array, default: () => [] },
    allTurnoHeaderValuesAlocacao: { type: Array, default: () => [] },
    allocationRejectedRows: { type: Array, default: () => [] },
    /**
     * Rótulo, contador e tooltip do botão de rejeitados. O pai alterna entre
     * "todos os rejeitados do filtro" e "só os marcados na tabela" conforme a
     * seleção; aqui é só exibição.
     */
    rejectedAllocationButtonLabel: { type: String, default: '' },
    rejectedAllocationButtonCount: { type: Number, default: 0 },
    rejectedAllocationButtonTooltip: { type: String, default: '' },
    allRejectedAllocationLoading: { type: Boolean, default: false },
    allocationSelection: { type: Array, default: () => [] },
    allocationPassengerKpiCards: { type: Array, default: () => [] },
    incompletePassengersTableHeaders: { type: Array, default: () => [] },
    incompletePassengers: { type: Array, default: () => [] },
    incompletePassengersLoading: { type: Boolean, default: false },
    incompleteTotal: { type: Number, default: 0 },
    incompleteNumberOfRows: { type: Number, default: 10 },
    incompleteItemsPerPageLastOption: { type: Number, default: 1000 },
    incompleteServerSortBy: { type: Array, default: () => [] },
    incompleteServerSortDesc: { type: Array, default: () => [] },
    incompletePassengersRowClass: { type: Function, default: null },
    loadIncompleteItemsForExport: { type: Function, default: null },
    rejectedAgglomerationTableHeaders: { type: Array, default: () => [] },
    rejectedAgglomerationClusters: { type: Array, default: () => [] },
  },
  data() {
    return {
      insertionStartMenu: false,
      insertionEndMenu: false,
      formValidLocal: this.allocationFormValid,
      syncingLazySelects: false,
      allocationPassengersAllMatching: false,
    };
  },
  watch: {
    formValidLocal(v) {
      this.$emit('update:allocationFormValid', v);
    },
    allocationFormValid(v) {
      this.formValidLocal = v;
    },
    unitFilter: {
      immediate: true,
      handler(val) {
        this.$nextTick(() => this.syncUnitSelect(val));
      },
    },
    agencyFilter: {
      immediate: true,
      handler(val) {
        this.$nextTick(() => this.syncAgencySelect(val));
      },
    },
    filtroTurnosSelected: {
      deep: true,
      immediate: true,
      handler(ids) {
        this.$nextTick(() => this.syncTurnosSelect(ids));
      },
    },
    allocationSelectedPassengerIds: {
      deep: true,
      immediate: true,
      handler(ids) {
        this.$nextTick(() => {
          const ref = this.$refs.allocationPassengersRef;
          if (ref && ref.internalAllMatching) return;
          this.syncPassengersSelect(ids, { emit: false });
        });
      },
    },
  },
  computed: {
    canClickValidate() {
      // allocationCanValidate no pai já considera IDs selecionados (lazy) + datas.
      // allMatching local cobre o instante antes do sync .sync para o pai.
      return this.allocationCanValidate || this.allocationPassengersAllMatching;
    },
    rejectedPassengerIds() {
      return new Set((this.allocationRejectedRows || [])
        .filter((row) => row && row.id_pessoa != null)
        .map((row) => String(row.id_pessoa)));
    },
    semUnidadeExtraItems() {
      return [{
        id_unidade: UNIT_FILTER_NONE,
        descricao_unidade: this.$t('routePlanning.fields.noUnit'),
        cod_unidade: 'SU',
      }];
    },
    semAgenciaExtraItems() {
      return [{
        id_agencia_emprego: AGENCY_FILTER_NONE,
        nome: this.$t('routePlanning.fields.noAgency'),
        cod_agencia: '',
      }];
    },
  },
  methods: {
    onPassengersAllMatching(val) {
      this.allocationPassengersAllMatching = !!val;
      this.$emit('update:allocationPassengersAllMatching', !!val);
    },
    async onValidateClick() {
      try {
        if (this.$refs.allocationTurnosRef
          && typeof this.$refs.allocationTurnosRef.resolveSelection === 'function') {
          const turnoIds = await this.$refs.allocationTurnosRef.resolveSelection();
          this.$emit('update:filtroTurnosSelected', turnoIds);
        }
        let passengerIds = Array.isArray(this.allocationSelectedPassengerIds)
          ? [...this.allocationSelectedPassengerIds]
          : [];
        if (this.$refs.allocationPassengersRef
          && typeof this.$refs.allocationPassengersRef.resolveSelection === 'function') {
          passengerIds = await this.$refs.allocationPassengersRef.resolveSelection();
          this.$emit('update:allocationSelectedPassengerIds', passengerIds);
        }
        this.allocationPassengersAllMatching = false;
        this.$emit('update:allocationPassengersAllMatching', false);
        await this.$nextTick();
        this.$emit('validate', passengerIds);
      } catch (_err) {
        // Erros de API já são exibidos pelo mixin/apiController.
      }
    },
    agencyItemText(item) {
      if (!item) return '';
      if (
        item.id_agencia_emprego === AGENCY_FILTER_NONE
        || String(item.id_agencia_emprego) === String(AGENCY_FILTER_NONE)
      ) {
        return item.nome || this.$t('routePlanning.fields.noAgency');
      }
      const code = item.cod_agencia != null ? String(item.cod_agencia).trim() : '';
      const name = item.nome != null ? String(item.nome).trim() : '';
      return code && name
        ? `${code} - ${name}`
        : (name || code || String(item.id_agencia_emprego));
    },
    isRejectedAllocationRow(item) {
      return !!(item && item.id_pessoa != null
        && this.rejectedPassengerIds.has(String(item.id_pessoa)));
    },
    onInsertionStart(value) {
      this.$emit('update:allocationInsertionStart', value);
      this.insertionStartMenu = false;
    },
    onInsertionEnd(value) {
      this.$emit('update:allocationInsertionEnd', value);
      this.insertionEndMenu = false;
    },
    onUnitInput(val) {
      if (this.syncingLazySelects) return;
      this.$emit('update:unitFilter', val);
    },
    onAgencyInput(val) {
      if (this.syncingLazySelects) return;
      this.$emit('update:agencyFilter', val);
    },
    syncUnitSelect(val) {
      const ref = this.$refs.unitSelect;
      if (!ref) return;
      this.syncingLazySelects = true;
      try {
        if (val == null || val === '') {
          if (typeof ref.resetData === 'function') ref.resetData();
          return;
        }
        const extra = (this.semUnidadeExtraItems || []).find(
          (i) => i && String(i.id_unidade) === String(val)
        );
        if (extra && typeof ref.cacheSelectedItems === 'function') {
          ref.cacheSelectedItems([extra], 'id_unidade');
        } else {
          const fromPick = (this.unitPickItems || []).find(
            (i) => i && String(i.value) === String(val)
          );
          if (fromPick && typeof ref.cacheSelectedItems === 'function') {
            ref.cacheSelectedItems([{
              id_unidade: fromPick.value,
              descricao_unidade: fromPick.text,
            }], 'id_unidade');
          }
        }
        if (typeof ref.setData === 'function') ref.setData(val);
      } finally {
        this.$nextTick(() => {
          this.syncingLazySelects = false;
        });
      }
    },
    syncAgencySelect(val) {
      const ref = this.$refs.agencySelect;
      if (!ref) return;
      this.syncingLazySelects = true;
      try {
        if (val == null || val === '') {
          if (typeof ref.resetData === 'function') ref.resetData();
          return;
        }
        const extra = (this.semAgenciaExtraItems || []).find(
          (i) => i && String(i.id_agencia_emprego) === String(val)
        );
        if (extra && typeof ref.cacheSelectedItems === 'function') {
          ref.cacheSelectedItems([extra], 'id_agencia_emprego');
        } else {
          const fromPick = (this.agencyPickItems || []).find(
            (i) => i && String(i.value) === String(val)
          );
          if (fromPick && typeof ref.cacheSelectedItems === 'function') {
            ref.cacheSelectedItems([{
              id_agencia_emprego: fromPick.value,
              nome: fromPick.text,
              cod_agencia: '',
            }], 'id_agencia_emprego');
          }
        }
        if (typeof ref.setData === 'function') ref.setData(val);
      } finally {
        this.$nextTick(() => {
          this.syncingLazySelects = false;
        });
      }
    },
    syncTurnosSelect(ids) {
      const ref = this.$refs.allocationTurnosRef;
      if (!ref || typeof ref.setData !== 'function') return;
      const next = Array.isArray(ids) ? [...ids] : [];
      const extras = Array.isArray(this.selectedTurnosForAllocationFilter)
        ? this.selectedTurnosForAllocationFilter
        : [];
      if (extras.length && typeof ref.cacheSelectedItems === 'function') {
        ref.cacheSelectedItems(extras, 'id_turno');
      }
      ref.setData(next);
    },
    syncPassengersSelect(ids, { emit = false } = {}) {
      const ref = this.$refs.allocationPassengersRef;
      if (!ref) return;
      const next = Array.isArray(ids) ? [...ids] : [];
      const extras = Array.isArray(this.selectedPassengersForAllocation)
        ? this.selectedPassengersForAllocation
        : [];
      if (extras.length && typeof ref.cacheSelectedItems === 'function') {
        ref.cacheSelectedItems(extras, 'id_pessoa');
      }
      if (emit && typeof ref.setSelectedItems === 'function') {
        ref.setSelectedItems(next);
        return;
      }
      if (typeof ref.setData === 'function') {
        ref.setData(next);
      }
    },
    /** Public API for parent (`Roteirizacao.vue`). */
    setSelectedPassengers(ids) {
      this.syncPassengersSelect(ids, { emit: true });
    },
    resetPassengers() {
      const ref = this.$refs.allocationPassengersRef;
      if (ref && typeof ref.resetData === 'function') {
        ref.resetData();
      }
    },
    setSelectedTurnos(ids) {
      this.syncTurnosSelect(ids);
    },
  },
};
</script>

<style scoped>
.allocation-filters-panel {
  margin-bottom: 16px;
  padding: 16px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  background: #fafafa;
}
.allocation-filters-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  column-gap: 16px;
  row-gap: 4px;
  align-items: start;
}
.allocation-filter-field {
  min-width: 0;
}
.allocation-filter-field .v-input {
  width: 100%;
  margin-top: 0;
}
.allocation-passenger-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 16px;
  align-items: center;
  margin-top: 12px;
}
.allocation-passenger-selector {
  flex: 1 1 220px;
  min-width: 0;
}
.allocation-validate-button-wrap {
  flex: 0 0 auto;
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
}
.allocation-validate-button {
  min-width: 132px !important;
  margin-top: 0;
}
@media (max-width: 1263px) {
  .allocation-filters-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 599px) {
  .allocation-filters-panel {
    padding: 12px;
  }
  .allocation-filters-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .allocation-passenger-actions {
    flex-direction: column;
    align-items: stretch;
  }
  .allocation-validate-button {
    width: 100%;
  }
}
</style>
